import {
	SWA_DELETE_TEMPLATE_NAME,
	SWA_OWNER_PAGE_PATH,
	SWA_PROVISION_TEMPLATE_NAME,
} from "@internal/backstage-plugin-avd-common";
import { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { TemplateFormPage } from "../layout/templateForm";

import { MY_WEB_APPS_DELETE_PATH, MY_WEB_APPS_HERO, MY_WEB_APPS_NEW_PATH } from "./swaEntitlement";

const BACK = { href: SWA_OWNER_PAGE_PATH, label: "Back to My web apps" };
// `<Routes>` under the page's mount wants the segment after it.
const segment = (path: string) => path.slice(`${SWA_OWNER_PAGE_PATH}/`.length);

/** My web apps and its two forms; anything else under it goes back to the page. */
export function WebAppsRoutes(props: Readonly<{ page: ReactNode }>): ReactNode {
	return (
		<Routes>
			<Route path="/" element={props.page} />
			<Route
				path={segment(MY_WEB_APPS_NEW_PATH)}
				element={
					<TemplateFormPage
						eyebrow={MY_WEB_APPS_HERO.eyebrow}
						title="Set up a web app."
						templateName={SWA_PROVISION_TEMPLATE_NAME}
						back={BACK}
					/>
				}
			/>
			<Route
				path={segment(MY_WEB_APPS_DELETE_PATH)}
				element={
					<TemplateFormPage
						eyebrow={MY_WEB_APPS_HERO.eyebrow}
						title="Delete a web app."
						templateName={SWA_DELETE_TEMPLATE_NAME}
						back={BACK}
					/>
				}
			/>
			<Route path="*" element={<Navigate to={BACK.href} replace />} />
		</Routes>
	);
}
